import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

const percent0to100Required = () =>
  Yup.number()
    .typeError('Invalid Beneficiary Percentage')
    .min(0, 'Invalid Beneficiary Percentage')
    .max(100, 'Invalid Beneficiary Percentage')
    .required('Required');

export const beneficiariesValidationSchema = (maxNumber?: number) =>
  Yup.object().shape({
    beneficiaries: Yup.array()
      .of(
        Yup.object().shape({
          id: requiredText(),
          addressId: requiredText(),
          beneficiaryPercentage: percent0to100Required()
        })
      )
      .test('max-count', 'Too many Beneficiaries', (arr) => {
        if (!maxNumber || !Array.isArray(arr)) return true;

        return arr.length <= maxNumber;
      })
      .test('sum-100', null, (arr, ctx) => {
        if (!Array.isArray(arr) || !arr.length) return true;

        const total = arr.reduce(
          (s, r: any) => s + (Number(r?.beneficiaryPercentage) || 0),
          0
        );
        const rounded = Math.round(total * 100) / 100;

        if (rounded !== 100) {
          const idx = Math.max(0, arr.length - 1);

          return ctx.createError({
            path: `${ctx.path}[${idx}].beneficiaryPercentage`,
            message: 'Beneficiary percentages shall sum to 100%'
          });
        }

        return true;
      })
  });
